<template>
	<div>
		<div style="background-color: #fff;">
			<div class="member">
				<div v-if="detailData">
					<div class="detail-title">{{ detailData.noticeTitle || '-' }}</div>
					<div class="detail-meta flex">
						<div class="flex-1">
							<span>作者：{{ detailData.author || '-' }}</span>
							<span class="type-tags">
								<span class="type-tag" v-for="(tag, idx) in (detailData.noticeTypeLabel || '').split(',')" :key="idx">{{ tag }}</span>
							</span>
						</div>
						<span>时间：{{ detailData.createTime || '-' }}</span>
					</div>
					<div class="detail-content" v-html="detailData.noticeContent || '-'"></div>
				</div>
				<div v-else>
					<p>加载中...</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import util from '@/utils/util';
export default {
	name: 'Index',
	data() {
		return {
			detailData: null,
		}
	},
	created() {
		const id = this.$route.query.id;
		console.log('接收到的id:', id);
		if (id) {
			this.getDetail(id);
		}
	},
	methods: {
		getDetail(id) {
			util.request({
				url: `/sy/website/getDetail`,
				method: 'GET',
				params: { id }
			}).then(res => {
				console.log('详情数据:', res);
				this.detailData = res.data || res;
			}).catch(error => {
				this.$message.error(error);
			});
		}
	}
}
</script>

<style scoped>
.member {
	width: 1200px;
	margin: 0 auto;
	padding-top: 70px;
	padding-bottom: 70px;
}
.flex {
	display: flex;
	align-content: center;
}
.flex-1 {
	flex: 1;
}
.detail-img {
	width: 100%;
	max-height: 400px;
	object-fit: cover;
	margin-bottom: 30px;
}
.detail-title {
	font-size: 24px;
	font-weight: 600;
	color: #333;
	margin-bottom: 20px;
}
.detail-meta {
	font-size: 14px;
	color: #999;
	margin-bottom: 30px;
}
.detail-meta span {
	margin-right: 10px;
}
.type-tags {
	margin-left: 0;
}
.type-tag {
	display: inline-block;
	padding: 1px 8px;
	font-size: 12px;
	color: #FE3D3A;
	background-color: rgba(254, 61, 58, 0.10);
	border-radius: 2px;
	margin-right: 8px;
}
.detail-content {
	font-size: 16px;
	color: #666;
	line-height: 1.8;
}
</style>


// WEBPACK FOOTER //
// src/view/pawnNewsDetail.vue